export enum GiftCardSendTypeEnum {
    BY_EMAIL = "BY_EMAIL",
    BY_SMS = "BY_SMS",
    BY_PDF = "BY_PDF"
}